import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { TemplateComponent } from '../shared/utils/models';
import { ContentService } from '../shared/content/content.service';

export const templateGuard: CanMatchFn = (route, segments) => {
    const contentService = inject(ContentService);
    const componentData: TemplateComponent[] =
        (contentService.pagesData as TemplateComponent[]) || [];
    const combinedSegments =
        '/' + segments.map((segment) => segment.path).join('/');
    const normalizedPath = combinedSegments.replace(/\/+$/, '').toLowerCase();

    return componentData.some((items: TemplateComponent) => {
        const itemPath = (items.path || '').replace(/\/+$/, '').toLowerCase();
        const templateType = (items.template || '').toLowerCase();

        return itemPath === normalizedPath && templateType === 'mega';
    });
};
